export default __webpack_public_path__ + "static/media/ecopro.534af9b3.png";